export const BID_SALE_AUCTION_STATUS = {
	pending: 'pending',
	live: 'live',
	overtime: 'overtime',
	deal_working: 'deal_working',
	ended: 'ended',
	future: 'future',
	sold: 'sold',
	failed: 'failed',
	expired: 'expired',
};

export const DEAL_WORKING_TURN = {
	BUY_SIDE: 'buy_side',
	SELL_SIDE: 'sell_side',
};

export const BID_SALE_PHASE = {
	negotiation: 'negotiation',
};
